import React, { useContext, useState } from "react"

import { useSnackbar } from "../../../../utils/notificacoes"
import RegistradorContext from "../../../../contexts/registradorContext"

import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Slide from "@material-ui/core/Slide"
import PrintIcon from "@material-ui/icons/Print"
import { Col, Row } from "react-bootstrap"

import { fecharmesa } from "../../../../services/integracao"

import { RegistrarLogErro } from "../../../../services/clientefiel"
import useAppStore from "../../../../stores/AppStore"
import useLoadingStore from "../../../../stores/LoadingStore"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

export default function Index() {
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    const setLoading = useLoadingStore(s => s.setLoading)

    const {
        finalizarMesa,
        setFinalizarMesa,
        cadastrarUsuario,
        setOpenGerenciarMesa,
        setOpenGerenciarPedidosMesa,
        setListaMesas,
        setPedidosDaMesa,
        pedidosDaMesa,
    } = useContext(RegistradorContext)

    // Impressão pelo store: sai na térmica (QZ) quando disponível e cai no
    // navegador só como fallback. O store já bloqueia impressão com assinatura
    // limitada, então a checagem local antiga saiu junto com o window.print().
    const mandarImprimir = useAppStore(s => s.mandarImprimir)

    // Pergunta "deseja imprimir?" ao fechar a mesa (só no fechamento final).
    const [perguntarImprimir, setPerguntarImprimir] = useState(false)

    const fecharPedidoMesa = async (pedidosDaMesa, imprimir) => {
        try {
            setLoading(true)
            const response = await fecharmesa(autorizacao, pedidosDaMesa)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                setLoading(false)
                return false
            }

            // Impressão do fechamento é LOCAL (nesta estação, 1 via na impressora
            // principal), disparada no próprio clique de "Fechar Mesa" e SÓ quando o
            // operador responde "Sim" à pergunta. Antes ela vinha por push do servidor/SSE
            // e duplicava: a mesma comanda era processada pelo push e pelo drain da fila —
            // e por mais de um Cabeçalho montado na aba do Registrador (página + diálogo da
            // mesa) —, saindo 2x na mesma impressora. Imprimindo aqui, uma única vez e de
            // forma determinística, o push do servidor deixa de ser necessário (e deve ser
            // removido no backend para não voltar a duplicar).
            const textoFechamento = response.impressao ?? pedidosDaMesa.impressao
            if (imprimir && textoFechamento)
                await mandarImprimir({ texto: textoFechamento, numeroDaImpressora: 1 })

            alertStart(`Mesa ${pedidosDaMesa.numeroMesa} fechada com sucesso!`, "success")

            setFinalizarMesa(false)
            setPedidosDaMesa({})
            setListaMesas([])
            setOpenGerenciarPedidosMesa(false)
            setOpenGerenciarMesa(false)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "fecharPedidoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const { enqueueSnackbar } = useSnackbar()

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    return finalizarMesa ? (
        <Dialog
            open={finalizarMesa}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setFinalizarMesa(false)}
        >
            <form onSubmit={cadastrarUsuario}>
                <DialogTitle>{`Fechar Mesa ${pedidosDaMesa.numeroMesa}`}</DialogTitle>
                <DialogContent>
                    {pedidosDaMesa.pedidosMesa.map((pedido, index) => (
                        <Row style={{ margin: "7px 0" }} key={index}>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    style={{ background: "#d8d8d8" }}
                                    fullWidth
                                    onClick={() => {
                                        mandarImprimir({ texto: pedido?.textoImpressao, qtd: 1 })
                                    }}
                                >
                                    <PrintIcon style={{ marginRight: "10px" }} />
                                    {index + 1}º Pedido{" "}
                                    {Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(pedido.valorTotal)}
                                </Button>
                            </Col>
                        </Row>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setFinalizarMesa(false)
                        }}
                    >
                        cancelar
                    </Button>
                    <Button
                        onClick={() => {
                            mandarImprimir({ texto: pedidosDaMesa.impressao, qtd: 1 })
                        }}
                        style={{ color: "#28a745" }}
                    >
                        Imprimir Todas
                    </Button>

                    <Button
                        onClick={() => {
                            setPerguntarImprimir(true)
                        }}
                        style={{ color: "white", background: "var(--cor-erro)" }}
                    >
                        Fechar Mesa
                    </Button>
                </DialogActions>
            </form>

            <Dialog open={perguntarImprimir} onClose={() => setPerguntarImprimir(false)}>
                <DialogTitle>Deseja imprimir a comanda de fechamento?</DialogTitle>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setPerguntarImprimir(false)
                            fecharPedidoMesa(pedidosDaMesa, false)
                        }}
                    >
                        Não
                    </Button>
                    <Button
                        onClick={() => {
                            setPerguntarImprimir(false)
                            fecharPedidoMesa(pedidosDaMesa, true)
                        }}
                        style={{ color: "white", background: "#28a745" }}
                        autoFocus
                    >
                        Sim
                    </Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
